<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <el-button type="primary" @click="addCategory">新增</el-button>
        <div class="table-wrapper">
            <el-table :data="cardCategoryStore.categories" v-loading="loading" style="width: 100%">
                <el-table-column prop="name" label="Name" width="160">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="editCategory(scope.row)">{{ scope.row.name
                            }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="Sort" width="80" />
                <el-table-column prop="image" label="Image" width="200">
                    <template #default="scope">
                        <img v-if="!!scope.row.image" class="table-image" :src="scope.row.image" alt="image"
                            loading="lazy" @click="openPreview(scope.row.index)" />
                    </template>
                </el-table-column>
                <el-table-column prop="packRarityParams" label="卡包稀有度" width="200">
                    <template #default="scope">
                        {{ Object.keys(scope.row.packRarityParams).join(',') }}
                    </template>
                </el-table-column>
                <el-table-column prop="cardRarityParams" label="卡片稀有度" width="200">
                    <template #default="scope">
                        {{ Object.keys(scope.row.cardRarityParams).join(',') }}
                    </template>
                </el-table-column>
            </el-table>
            <el-image-viewer v-if="showPreview" :url-list="cardCategoryStore.categories.map(row => row.image)"
                :initial-index="previewIndex" @close="showPreview = false" :hide-on-click-modal="true" />
        </div>

        <el-dialog v-model="newCategoryParams.showDialog" :title="newCategoryParams.id ? '修改分类' : '新增分类'" width="600px">
            <el-form :model="newCategoryParams" label-width="150px">
                <el-form-item label="名称" prop="name" required>
                    <el-input v-model="newCategoryParams.name" maxlength="20" show-word-limit
                        word-limit-position="outside" />
                </el-form-item>
                <el-form-item label="排序值" prop="sort" required>
                    <el-input-number v-model="newCategoryParams.sort" />
                </el-form-item>
                <el-form-item label="图片" prop="image">
                    <SingleImageUploader v-model="newCategoryParams.image"></SingleImageUploader>
                </el-form-item>
                <el-form-item label="卡包稀有度参数配置" prop="packRarityParams" required>
                    <el-input v-model="newCategoryParams.packRarityParams" />
                </el-form-item>
                <el-form-item label="卡片稀有度参数配置" prop="cardRarityParams" required>
                    <el-input v-model="newCategoryParams.cardRarityParams" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="newCategoryParams.showDialog = false">取消</el-button>
                <el-button v-loading="newCategoryParams.loading" type="primary" @click="submit">确定</el-button>
            </template>
        </el-dialog>
    </el-card>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { useCardCategoryStore } from "@/stores/card/category";

const cardCategoryStore = useCardCategoryStore();

const loading = ref(false);

const newCategoryParams = reactive({
    showDialog: false,
    id: "",
    name: "",
    sort: 50,
    image: "",
    packRarityParams: "{}",
    cardRarityParams: "{}",
    loading: false,
});

const showPreview = ref(false);
const previewIndex = ref(0);

const openPreview = (index) => {
    previewIndex.value = index
    showPreview.value = true
}

async function loadData() {
    loading.value = true;

    const response = await cardCategoryStore.getAll();
    if (!response) {
        return false;
    }

    loading.value = false;
}

function addCategory() {
    newCategoryParams.id = "";
    newCategoryParams.name = "";
    newCategoryParams.sort = 50;
    newCategoryParams.image = "";
    newCategoryParams.packRarityParams = "{}";
    newCategoryParams.cardRarityParams = "{}";
    newCategoryParams.showDialog = true;
}

function editCategory(row) {
    newCategoryParams.id = row.id;
    newCategoryParams.name = row.name;
    newCategoryParams.sort = row.sort;
    newCategoryParams.image = row.image;
    newCategoryParams.packRarityParams = JSON.stringify(row.packRarityParams);
    newCategoryParams.cardRarityParams = JSON.stringify(row.cardRarityParams);
    newCategoryParams.showDialog = true;
}

async function submit() {
    let success = false;
    if (!newCategoryParams.id) {
        success = await submitAddCategory();
    } else {
        success = await submitEditCategory();
    }

    if (success) {
        newCategoryParams.showDialog = false;
    }
}

async function submitAddCategory() {
    let prp = {};
    let crp = {};
    try {
        prp = JSON.parse(newCategoryParams.packRarityParams);
        crp = JSON.parse(newCategoryParams.cardRarityParams);
    } catch (error) {
        ElMessage.error(error.message);
        return;
    }

    newCategoryParams.loading = true;

    const response = await cardCategoryStore.add({
        name: newCategoryParams.name,
        sort: newCategoryParams.sort,
        image: newCategoryParams.image,
        packRarityParams: prp,
        cardRarityParams: crp,
    });
    newCategoryParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("增加分类成功");
    return true;
}

async function submitEditCategory() {
    let prp = {};
    let crp = {};
    try {
        prp = JSON.parse(newCategoryParams.packRarityParams);
        crp = JSON.parse(newCategoryParams.cardRarityParams);
    } catch (error) {
        ElMessage.error(error.message);
        return;
    }

    newCategoryParams.loading = true;

    const response = await cardCategoryStore.edit(newCategoryParams.id, {
        name: newCategoryParams.name,
        sort: newCategoryParams.sort,
        image: newCategoryParams.image,
        packRarityParams: prp,
        cardRarityParams: crp,
    });
    newCategoryParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("修改分类成功");
    return true;
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped>
.table-image {
    width: 80px;
    height: 50px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
}
</style>
